<template>
    <div>
        <v-form ref="form">
            <v-row class="justify-center  align-center mt-12">
                <v-file-input
                    label="ファイルを選択"
                    accept="audio/mpeg"
                    :rules="fileRules"
                    @change="getFileName"
                    v-model="input.upload_file"
                    chips
                    truncate-length="13"
                    class="shrink"
                    clearable
                ></v-file-input>
            </v-row>
            <v-row class="justify-center  align-center mt-2">
                <v-text-field
                    label="ファイル名"
                    :rules="fileNameRules"
                    clearable
                    v-model="input.file_name"
                    class="shrink"
                    >
                </v-text-field>
            </v-row>
            <v-row class="justify-center  align-center mt-2">
            <v-select
                label="曲のタグを選択"
                :rules="tagRules"
                v-model="input.selected_tag"
                :items="$store.state.tags"
                clearable
                class="shrink"
            ></v-select>
            </v-row>
        </v-form>
        <v-row class="justify-center  align-center mt-2 mb-2"
        >
            <v-dialog v-model="dialog"
                transition="dialog-bottom-transition"
                max-width="400"
            >
                <template>
                    <v-card>
                        <v-toolbar
                            color="purple"
                            dark
                            height="30%"
                        >Score</v-toolbar>
                        <v-card-text>
                            <v-row class="justify-center  align-center my-8">
                                <ScoreBoard :score='score' :ranking='ranking'></ScoreBoard>
                            </v-row>
                            <v-row class="justify-center  align-center my-8">
                                {{ getMsg }}
                            </v-row>
                        </v-card-text>
                        <v-card-actions class="justify-end">
                            <v-btn
                                text
                                @click="dialog = false"
                            >Close
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>
            </v-dialog>
        </v-row>
        <v-row class="justify-center  align-center my-8">
            <!-- 得点表示 -->
            <span v-if="isAssessed">
                <ScoreBoard :score='score' :ranking='ranking'></ScoreBoard>
            </span>
            <!-- ローディング表示 -->
            <span v-if="this.$store.state.isLoading">
                <v-progress-circular v-if="this.$store.state.isLoading"
                    :size="70"
                    :width="7"
                    color="purple"
                    indeterminate
                ></v-progress-circular>
            </span>
        </v-row>
<!-- エラー表示 -->
        <v-row class="justify-center  align-center my-8" v-if="error">
                {{ error }}
        </v-row>
<!-- ログイン注意 -->
        <v-row
            v-if="!$store.state.user"
            class="justify-center  align-center my-2 p-2"
        >
            記録を保存するには、ログインが必要です
        </v-row>
<!-- 採点ボタン -->
        <v-row
            v-if="!isAssessed"
            class="justify-center  align-center mt-8"
        >
            <v-btn
                width="170"
                rounded
                color="deep-purple"
                dark
                @click="assessmentRequest()"
            >
                採点する
            </v-btn>
        </v-row>
<!-- ランキング公開チェックボックス -->
        <v-row
            v-if="isAssessed && $store.state.user"
            class="justify-center  align-center mt-1"
        >
            <v-checkbox
                v-model="checkbox"
                color="red"
                :label="`ランキングにも公開する`"
            ></v-checkbox>
        </v-row>
<!-- 記録保存ボタン -->
        <v-row
            class="justify-center  align-center mt-1"
            v-if="isAssessed && $store.state.user"
        >
            <v-btn
                v-if="!isSaved"
                width="170"
                rounded
                color="deep-purple"
                dark
                :loading="isSaving"
                @click="saveRequest()"
            >
                記録を保存する
            </v-btn>
            <v-btn
                class="isSaved"
                v-if="isSaved"
                width="170"
                rounded
                color="black"
                dark
                :loading="isSaving"
            >
                登録完了!
            </v-btn>
        </v-row>
<!-- リセットボタン -->
        <v-row
            v-if="isAssessed"
            class="justify-center  align-center mt-10"
        >
            <v-btn
                width="170"
                rounded
                color="deep-purple"
                dark
                @click="reset()"
            >
                リセット
            </v-btn>
        </v-row>
        
    </div>
</template>

<script>
import ScoreBoard from "@/components/ScoreBoard"
import axios from 'axios'
import { Storage } from 'aws-amplify'
export default {
name: "Assessment",
components: {
    ScoreBoard
},
data(){
    return {
        fileRules: [
            v => !v || v.size < 20000000 || '20 MB以下のファイルを選択してください',
            v => !!v || 'ファイルを選択してください',
            v => (v && v.size > 0) || 'ファイルを選択してください'
        ],
        fileNameRules: [
            v => !!v || 'ファイル名を入力してください',
            v => v.length <= 30 || 'ファイル名は30文字以下で入力してください',
        ],
        tagRules: [
            v => !!v || '曲のタグを選択してください'
        ],
        input: {
            upload_file: null,
            file_name: '',
            selected_tag: '',
        },
        dialog: false,
        score: "",
        error: "",
        msg:{
            0: "もっと上手くなれる！！",
            1: "この調子！!",
            2: "凄い！！",
            3: "おめでとうございます！あなたはプロ級です！！"
            },
        isAssessed: false,
        isSaving: false,
        isSaved: false,
        checkbox: false,
        callTimes: 0,
        fileId: null,
        ranking: { max: null , rank: null },
        execTaskName: null
    }
},
computed: {
    getMsg: function(){
            if (this.score >= 90){
                return this.msg[3]
            }else if (this.score >= 80){
                return this.msg[2]
            }else if (this.score >= 60){
                return this.msg[1]
            }else{
                return this.msg[0]
            }
        }
    },
methods: {
    getFileName(e){
        this.input.file_name = e.name;
    },
    getUniqueStr(){
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
        })
    },
    saveFile(fileId){
        return Storage.put(`${this.$store.state.username}/${fileId}.mp3`, this.input.upload_file)
    },
    async executeStepFunction(){
        // apiへの送信情報を定義
        const apiUrl = "https://flhrsaddm1.execute-api.ap-northeast-1.amazonaws.com/dev/scoring";
        const headers = {
            headers: {
                "Content-Type": "application/json"
            }
        }

        const input_path = "s3://devpsa2161052-dev/public/" + this.$store.state.username + "/" + this.fileId + ".mp3"
        const input_obj = { "path": input_path }
        const req_body = {
                "input": JSON.stringify(input_obj),
                "stateMachineArn": "arn:aws:states:ap-northeast-1:655146334141:stateMachine:p-kai-scoring"
            };
        const result =  await axios.post(apiUrl,req_body,headers) 
        this.execTaskName = result.data.executionArn;
    },
    async describeStepFunction(){
        // apiへの送信情報を定義
        const apiUrl = "https://flhrsaddm1.execute-api.ap-northeast-1.amazonaws.com/dev/scoring/status";
        const headers = {
            headers: {
                "Content-Type": "application/json"
            }
        }
        const req_body = {
                executionArn : this.execTaskName
            };
        const result = await axios.post(apiUrl,JSON.stringify(req_body),headers)
        return result
    },
    async receiveETStateAndBranch(result) {
        //resultからStepfunctionのステータスを取得
        const ETState  = result.data.status
        //結果次第で処理を分岐
        if (ETState === "FAILED") {
            this.$store.commit("setLoading", false );
            this.error = "実行エラーが発生しました"
        }else if (ETState === "SUCCEEDED") {
            this.$store.commit("setLoading", false );
            //結果からscoreを取得
            const resBody = JSON.parse(result.data.output).body
            this.score = JSON.parse(resBody).score

            this.dialog = true;
            this.isAssessed = true;

        }else if (ETState === "RUNNING") {
            await new Promise(resolve => setTimeout(resolve, 10000))
            this.callTimes++
            console.log(this.callTimes)
            this.repeatConfirm()
        }
    },
    async repeatConfirm(){
        //カウントが10回以上だったらタイムアウトエラー
        if (this.callTimes >= 90) {
            this.$store.commit("setLoading", false );
            this.error = "タイムアウトエラー"
            return;
        }
        //StepFunctionの状態を取得する
        const result = await this.describeStepFunction()
        //結果を見て分岐させる
        this.receiveETStateAndBranch(result)
    },
    async assessmentRequest(){
        //入力値にエラーがあればreturn
        if(!this.$refs.form.validate()) return
        this.error = null
        this.$store.commit("setLoading", true )
        this.callTimes = 0
        try{
            // ファイルIDを生成して、ファイルをS3に保存
            this.fileId = this.getUniqueStr()
            await this.saveFile(this.fileId)
            //StepFunctionを実行
            await this.executeStepFunction()
            //状態を確認して、結果を見て分岐
            await this.repeatConfirm()
        }catch(err){
            console.log(err);
            this.error = "通信エラーが発生しました"
            this.$store.commit("setLoading", false );
        }
    },
    saveRequest(){
        this.isSaving = true;
        // apiへの送信情報を定義
        const apiUrl = "https://flhrsaddm1.execute-api.ap-northeast-1.amazonaws.com/dev";
        const ranking = this.checkbox ? true : false;
        const post_data = { 
            user : this.$store.state.username,
            file_id: this.fileId,
            file_name: this.input.file_name,
            tag : this.input.selected_tag,
            score : this.score,
            ranking: ranking
        };
        const headers = {
            headers: {
                "Content-Type": "application/json"
            }
        }
        // POST送信
        axios.post(apiUrl,post_data,headers)
        .catch((err) => {
            console.log(err);
        })
        .finally(() => { 
            this.isSaving = false;
            this.isSaved = true;
        })
    },
    reset(){
        this.input = { 
            upload_file: null,
            file_name: null,
            selected_tag: null,
        };
        this.score = null;
        this.isAssessed = false;
        this.isSaved = false;
    }
}
};

</script>

<style>
.shrink{
    width: 50%;
}
.isSaved{
    cursor: default;
}
</style>